import { render, staticRenderFns } from "./HistorialTiposProducto.vue?vue&type=template&id=65604c6d&scoped=true&"
import script from "./HistorialTiposProducto.vue?vue&type=script&lang=ts&"
export * from "./HistorialTiposProducto.vue?vue&type=script&lang=ts&"
import style0 from "./HistorialTiposProducto.vue?vue&type=style&index=0&id=65604c6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65604c6d",
  null
  
)

export default component.exports